import StandalonePillBoxMultiSelect from '../../components/Form/StandalonePillBoxMultiSelect'

export type LastScannedType = 'OneToFortyDays' | 'FortyOneToEightyDays' | 'EightyDaysPlus'

const options: {
  id: string | number
  value: LastScannedType
  label: string
  color: 'green' | 'yellow' | 'orange'
}[] = [
  { id: '1_40', value: 'OneToFortyDays', label: '1-40 days', color: 'green' },
  {
    id: '41_80',
    value: 'FortyOneToEightyDays',
    label: '41-80 days',
    color: 'yellow',
  },
  { id: '80_', value: 'EightyDaysPlus', label: '80 days +', color: 'orange' },
]

export interface LastScannedSelectProps {
  value: LastScannedType[]
  onChange: (value: LastScannedType[]) => void
}

export default function LastScannedSelect({
  value,
  onChange,
}: LastScannedSelectProps) {
  return (
    <StandalonePillBoxMultiSelect
      placeholder={'Last Scanned'}
      value={value}
      options={options}
      onChange={onChange}
    />
  )
}
